
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter?id=data-v-4c3fcb50!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=styles&index=0!./dashboard.vue")

var Component = require("!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./dashboard.vue"),
  /* template */
  require("!!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-4c3fcb50!../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./dashboard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/editor/src/modules/color/dashboard.vue
// module id = 542
// module chunks = 0